module.exports = __webpack_public_path__ + "static/media/profilebg.4e2ebeed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/profilebg.jpg
// module id = 1476
// module chunks = 0